export const convertHindiToArabic = (input: string): string => {
    const hindiToArabicMap: { [key: string]: string } = {
      '٠': '0', '١': '1', '٢': '2', '٣': '3', '٤': '4',
      '٥': '5', '٦': '6', '٧': '7', '٨': '8', '٩': '9'
    };
  
    return input.replace(/[٠-٩]/g, (match) => hindiToArabicMap[match]);
  };